import React from 'react'
import { BANKING_BOTTOM_CONTENT, CERTIFICATION_COURSE_PAGE_3, CERTIFICATION_DETAILS_PAGE_3, CERTIFICATION_HERO_PAGE_3 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { CERTIFICATION_ACCORDIAN_3 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const CertificationPage_3 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...CERTIFICATION_HERO_PAGE_3}/>
     <CoursesAside {...CERTIFICATION_COURSE_PAGE_3}/>
     <CourseCard {...CERTIFICATION_DETAILS_PAGE_3}/>
     <Accordian {...CERTIFICATION_ACCORDIAN_3}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default CertificationPage_3